import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AppointmentService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/appointment", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/appointment/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  // AppointmentService.getList
  getList: async ({ month, year, agentIds }) => {
    const params = new URLSearchParams();

    if (month) params.append("month", month);
    if (year) params.append("year", year);

    if (agentIds?.length) {
      agentIds.forEach((id) => params.append("agentIds", id));
    }

    const response = await apiService.get(
      `/appointment/month?${params.toString()}`
    );
    return response.data;
  },

  getDetail: async (id) => {
    const response = await apiService.get(`/appointment/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(`/appointment/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/appointment/${id}`);
    return response.data;
  },
};

export default AppointmentService;
